import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.highlightDifferences()
  }

  highlightDifferences() {
    // Get all product columns
    const productColumns = this.element.querySelectorAll('[data-index]')
    if (productColumns.length < 2) return

    // Get all attributes (alcohol, allergen, etc.)
    const attributeKeys = ['alcohol', 'allergen', 'fragrance', 'oil', 'paraben', 'silicone', 'sulfate', 'cruelty', 'fungal', 'reef', 'vegan']

    attributeKeys.forEach(key => {
      // Find the badge for this attribute in each product column
      const badges = Array.from(productColumns).map(column =>
        column.querySelector(`[data-attribute-key="${key}"]`)
      ).filter(badge => badge !== null)

      if (badges.length < 2) return

      // Check if values differ by looking at the bg color of the checkmark/x icon
      const values = badges.map(badge => {
        const icon = badge.querySelector('.size-6')
        return icon?.classList.contains('bg-green-400')
      })

      // If values are not all the same, highlight them
      const hasDifference = values.some(v => v !== values[0])
      if (hasDifference) {
        badges.forEach(badge => {
          badge.classList.add('bg-indigo-50', 'rounded-lg')
        })
      }
    })
  }
}
